import { withInstall } from '../utils'
import _Tab from './Tab'
import './index.scss'

export const Tab = withInstall(_Tab)
export default Tab
